export default "__VITE_ASSET__BtmbILVX__"